import { createSlice } from '@reduxjs/toolkit';
import { regionSnapshotApi, regionInstanceApi } from '../services';
import { RootState } from './index';

interface IAccount {
  snapshots: Record<string, any>;
}

const initialState: IAccount = {
  snapshots: {}
};

const snapshotSlice = createSlice({
  name: 'snapshot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      regionSnapshotApi.endpoints.getSnapshotList.matchFulfilled,
      (state, { payload }) => {
        state.snapshots = payload?.data;
      }
    );

    // builder.addMatcher(
    //   regionInstanceApi.endpoints.getInstanceState.matchFulfilled,
    //   (state, {payload}) =>{
    //     const status = payload?.status;
    //     if (status === )
    //   }
    // )
  }
});

const { reducer, actions } = snapshotSlice;

export const selectSnapshots = (state: RootState) => state.snapshot?.snapshots;

export default reducer;
